<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <h2>
                Todo lo que necesitas para vender en línea
            </h2>
            <p>Triidy es una plataforma Dropshipping que puedes usar completamente gratis, además cuando empiezas a generar ventas, aumentan los beneficios, sube de nivel y conviertete en un Máster en ventas digitales
            </p>
            <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
            <button class="btn" (click)="clickM()">Regístrate Ahora</button>
        </div>
        <div class="col right">
            <img class="princ" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Nosotros-new.png" alt="">
            <img class="globo1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo1-new.png" alt="">
            <img class="globo2" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo2-new.png" alt="">
            <img class="globo3" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo3-new.png" alt="">
            <img class="globo4" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Globo4-new.png" alt="">
        </div>
    </div>
    <div class="row secc2">
        <button class="btn mobile" (click)="selectBen(1)" [ngStyle]="{'background-color':niveles[0] === true ? '#FF8701': 'transparent', 'color':niveles[0] === true ? '#fff': '#FF8701' }">Level
            1 - Emprendedores
            Digitales</button>
        <button class="btn mobile" (click)="selectBen(2)" [ngStyle]="{'background-color':niveles[1] === true ? '#FF8701': 'transparent', 'color':niveles[1] === true ? '#fff': '#FF8701'  }">Level
            2 - Ecommerce
            Avanzado</button>
        <button class="btn mobile" (click)="selectBen(3)" [ngStyle]="{'background-color':niveles[2] === true ? '#FF8701': 'transparent', 'color':niveles[2] === true ? '#fff': '#FF8701'  }">Level
            3 - Escalador
            Experto</button>
        <button class="btn mobile" (click)="selectBen(4)" [ngStyle]="{'background-color':niveles[3] === true ? '#FF8701': 'transparent', 'color':niveles[3] === true ? '#fff': '#FF8701'  }">Level
            4 - Master en Ventas
            D</button>
        <table class="mobile">
            <thead>
                <tr>
                    <th colspan="2" *ngIf="niveles[0]">
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl1-new.png" alt="">
                        <div>
                            Emprendedores Digitales
                            <br> 0 - 150 ventas
                        </div>
                    </th>
                    <th colspan="2" *ngIf="niveles[1]">
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl2-new.png" alt="">
                        <br> Ecommerce Avanzado
                        <br> 151 - 350 ventas
                    </th>
                    <th colspan="2" *ngIf="niveles[2]">
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl3-new.png" alt="">
                        <br> Escalador Experto
                        <br> 351 - 800 ventas
                    </th>
                    <th colspan="2" *ngIf="niveles[3]">
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl4-new.png" alt="">
                        <br> Master en Ventas Digitales
                        <br> Más de 800 ventas
                    </th>
                </tr>
                <tr>
                    <th colspan="2" style="color: #FF8701">
                        Beneficios
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ben of Beneficios">
                    <td class="first">{{ ben.titulo }}</td>
                    <td *ngIf="niveles[0]">
                        <span *ngIf="!ben.text"><i *ngIf="ben.lvl1" class="fas fa-check"></i><i *ngIf="!ben.lvl1"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl1 }}</span>
                    </td>
                    <td *ngIf="niveles[1]">
                        <span *ngIf="!ben.text"><i *ngIf="ben.lvl2" class="fas fa-check"></i><i *ngIf="!ben.lvl2"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl2 }}</span>
                    </td>
                    <td *ngIf="niveles[2]">
                        <span *ngIf="!ben.text"><i *ngIf="ben.lvl3" class="fas fa-check"></i><i *ngIf="!ben.lvl3"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl3 }}</span>
                    </td>
                    <td *ngIf="niveles[3]">
                        <span *ngIf="!ben.text"><i *ngIf="ben.lvl4" class="fas fa-check"></i><i *ngIf="!ben.lvl4"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl4 }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="benefi navegador">
            <thead>
                <tr>
                    <th class="first"><span>Beneficios</span></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ben of Beneficios">
                    <td class="first">{{ ben.titulo }}</td>
                </tr>
            </tbody>
        </table>
        <table class="levels navegador">
            <thead>
                <tr>
                    <th>
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl1-new.png" alt="">
                        <br> Emprendedores Digitales
                        <br> 0 - 150 ventas
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ben of Beneficios">
                    <td>
                        <span *ngIf="!ben.text"><i *ngIf="ben.lvl1" class="fas fa-check"></i><i *ngIf="!ben.lvl1"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl1 }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="levels sup navegador">
            <thead>
                <tr>
                    <th>
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl2-new.png" alt="">
                        <br> Ecommerce Avanzado
                        <br> 151 - 350 ventas
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ben of Beneficios">
                    <td><span *ngIf="!ben.text"><i *ngIf="ben.lvl2" class="fas fa-check"></i><i *ngIf="!ben.lvl2"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl2 }}</span></td>
                </tr>
            </tbody>
        </table>
        <table class="levels navegador">
            <thead>
                <tr>
                    <th>
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl3-new.png" alt="">
                        <br> Escalador Experto
                        <br> 351 - 800 ventas
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ben of Beneficios">
                    <td><span *ngIf="!ben.text"><i *ngIf="ben.lvl3" class="fas fa-check"></i><i *ngIf="!ben.lvl3"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl3 }}</span></td>
                </tr>
            </tbody>
        </table>
        <table class="levels sup navegador">
            <thead>
                <tr>
                    <th>
                        <img class="" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/lvl4-new.png" alt="">
                        <br> Master en Ventas Digitales
                        <br> Más de 800 ventas
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let ben of Beneficios">
                    <td><span *ngIf="!ben.text"><i *ngIf="ben.lvl4" class="fas fa-check"></i><i *ngIf="!ben.lvl4"
                                class="fas fa-times"></i></span><span *ngIf="ben.text">{{ ben.lvl4 }}</span></td>
                </tr>
            </tbody>
        </table>
    </div>
    <!--     <div class="row secc3">
        <p>Vende como quieras, <span>Triidy</span> se integra con</p>
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Shopi-new2.png" alt="">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Face-new2.png" alt="">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Insta-new2.png" alt="">
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Wasa-new2.png" alt="">
    </div> -->
    <div class="row secc4">
        <img class="figure1" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Elipse3-new.png" alt="">
        <img class="figure2" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Stroke3-new.png" alt="">
        <div class="row cuad-int">
            <h2>Empieza ahora y descubre todo el poder de las tecnologias Dropshipping de Triidy</h2>
            <!-- <button class="btn" routerLink="/Regístrate">Regístrate Ahora</button> -->
            <button class="btn" (click)="clickM()">Regístrate Ahora</button>
        </div>
    </div>
    <div class="row secc5">
        <div class="col imag">
            <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/pc_trii_3.png" alt="Triidy">
        </div>
        <div class="col cuad-int">
            <h2>Descarga Triidy y empieza a generar dinero. <br> <span>Facíl, con Triidy</span></h2>
            <img class="down" (click)="descargaAnd()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/GooglePlay-new.png" alt="">
            <img class="down" (click)="descargaWin()" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Windows-new.png" alt="">
            <p>Aprende a usar Triidy</p>
        </div>
    </div>
    <div class="row secc6">
        <p>Con el apoyo y acompañamiento de:</p>
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Acompa12-new.png" alt="">
    </div>
</div>